<template>
  <div class="page-module-wrap">
    <div class='button-wrap'>
      <button class='button is-info' @click='addSource'>新增</button>
      <button class='button' @click='tagSetting'>ICON标签设置</button>
      <button class="button is-success" @click="goBack">返回</button>
    </div>
    <div class='table-wrap'>
      <table class="table is-bordered">
        <thead>
          <tr>
            <th>内容源ID</th>
            <th>类型</th>
            <th>账号</th>
            <th>抓取关键词</th>
            <th>关联时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for='(item,index) in sourceList'>
            <td>
              <router-link v-if='item.type == 10 || item.type == 11 || item.type == 12' class='v-link' :to='{name: "editSource", query: {accountId: item.accountId, name: getAccountName(item.type), type: item.type}}'>{{item.accountId}}</router-link >
              <div v-else>{{item.accountId}}</div>
            </td>
            <td>{{getAccountName(item.type)}}</td>
            <td>{{item.accountName}}</td>
            <td>{{item.keywords.join(',')}}</td>
            <td>{{item.createTime}}</td>
            <td>
              <el-button type="primary" :disabled="item.updating > 0" @click='manualUpdate(index, item.accountId, item.type)'>手动更新</el-button>
              <button class='button is-danger' @click='deleteSource(index, item.accountId)'>删除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <el-dialog
      :title="modal.title"
      :visible.sync="modal.visible"
      width="30%">
      <div v-if='modalType === 0' class='modal-wrap'>
        <div class='source-type-wrap'>
          <label for="source">选择内容源类型:</label>
          <span class="select">
            <select v-model='modal.sourceType' @change="sourceTypeChange(modal.sourceType)">
              <option v-for='sourceType in sourceTypeList' :value="sourceType.type">{{sourceType.name}}</option>
            </select>
          </span>
        </div>
        <div v-show='modal.accountList.length' class='account-wrap'>
          <label for="source">选择账号:</label>
          <el-select v-model="modal.accountId" filterable placeholder="请选择">
            <el-option
              v-for="item in modal.accountList"
              :key="item.accountId"
              :label="item.accountName"
              :value="item.accountId">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if='modalType === 1' class='modal-wrap'>
        <div class="block"><label class="label inline-block r-top">ICON标签设置</label></div>
        <input-tag :on-change="tagCallback" :tags="tagList" placeholder="请输入标签，并按回车后确认"></input-tag>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modal.visible = false">取 消</el-button>
        <el-button type="primary" @click="MODAL_OK_EVENT">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
  import InputTag from './inputTag';

  export default {
    data(){
      return {
        sourceList: [],
        sourceTypeList: [],
        modal: {
          title: '',
          visible: false,
          sourceType: '',
          accountList: [],
          accountId: '',
        },
        tagList: [],
        modalType: 0
      }
    },
    computed: {
      bloggerId() {
        return this.$route.query.bloggerId
      }
    },
    components:{
      InputTag
    },
    created(){
      this.getSource()
    },
    methods: {
      manualUpdate(index, accountId, type) {
        HttpRequest.get("/admin.php?method=fashion.manualUpdateSource", {accountId: accountId, type: type}).then((response) => {
          this.$message("更新中......")
          this.sourceList[index].updating = 1
        })
      },
      MODAL_OK_EVENT() {
        if (this.modalType === 0) {
          this.doSaveRelatedSource()
        } else {
          this.doSaveTag()
        }
      },
      getSource() {
        HttpRequest.get("/admin.php?method=fashion.getSourceTypeList").then((response) => {
          this.sourceTypeList = response.data
        }).then(() => {
          this.getSourceList()
        })
      },
      getSourceList() {
        let params = {
          bloggerId: this.bloggerId,
        }
        HttpRequest.get("/admin.php?method=blogger.getSourceList", params, true).then((response) => {
          this.sourceList = response.data.list
        });
      },
      addSource() {
        this.modalType = 0
        this.modal = {
          title: '新增内容源',
          visible: true,
          sourceType: '',
          accountId: '',
          accountList: []
        }
      },
      deleteSource(index, accountId) {
        if (confirm('确定删除?')) {
          this.sourceList.splice(index, 1)
          let params = {
            bloggerId: this.bloggerId,
            accountId: accountId
          }
          HttpRequest.get("/admin.php?method=blogger.deleteSource",params)
        }
      },
      sourceTypeChange(sourceType) {
        HttpRequest.get("/admin.php?method=fashion.getSourceList", { type: sourceType }).then((response) => {
          if (response.data && response.data.list) {
            this.modal.accountList = response.data.list
          } else {
            this.modal.accountList = []
          }
        })
      },
      tagSetting() {
        this.modalType = 1
        this.modal = {
          title: '编辑内容源',
          visible: true
        }
        HttpRequest.get("/admin.php?method=blogger.getIconTagList", {bloggerId: this.bloggerId}).then((response) => {
          this.tagList = response.data.list
        })
      },
      tagCallback(tags) {
        this.tagList = tags
      },
      doSaveTag() {
        let params = {
          bloggerId: this.bloggerId,
          tags: this.tagList
        }
        this.modal.visible = false;
        HttpRequest.post("/admin.php?method=blogger.doSaveIconTags", params)
      },
      doSaveRelatedSource() {
        let params = {
          bloggerId: this.bloggerId,
          type: this.modal.sourceType,
          accountId: this.modal.accountId
        }
        HttpRequest.post("/admin.php?method=blogger.doSaveSource", params).then((response) => {
          this.getSourceList()
          this.modal.visible = false;
        })
      },
      getAccountName(type) {
        let accountName = ''
        this.sourceTypeList.forEach((item) => {
          if (item.type == type) {
            accountName = item.name
          }
        })
        return accountName
      },
      goBack() {
        this.$router.push({
          name: 'cyzsIcon',
          query: {
            page: this.$route.query.page,
            selectedBlogger: this.$route.query.selectedBlogger,
            activeIndex: this.$route.query.activeIndex,
            categoryId: this.$route.query.categoryId,
          }
        })
      }
    }
  }
</script>

<style rel="stylesheet/less" lang="less" scoped>
  .table-wrap {
    margin-top: 20px;
  }
  table td {
    text-align: center;

    button {
      margin-left: 5px;
    }
  }
  .modal-wrap {
    padding: 0 50px 50px;
    .source-type-wrap {
      margin-bottom: 5px;
    }
  }
  .v-link {
    color: #1fc8db;
    cursor: pointer;
  }
  .account-wrap {
    position: absolute;
    display: flex;
  }
</style>
